import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignCreateComponent } from './campaign-create/campaign-create.component';
import { CampaignListComponent } from './campaign-list/campaign-list.component';
import { CampaignViewsComponent } from './campaign-views/campaign-views.component';
import { CampaignRoutingModule } from '@app/campaign/campaign-routing.module';
import { SharedModule } from '@app/shared';
import { FilterService } from '@progress/kendo-angular-grid';

@NgModule({
  declarations: [CampaignCreateComponent, CampaignListComponent, CampaignViewsComponent],
  imports: [CommonModule, CampaignRoutingModule, SharedModule],
  providers: [FilterService],
  exports: [],
})
export class CampaignModule {}
